import { Radio } from "antd";
import styled from "styled-components";

export const AntRadioButton = styled(Radio)`
  .ant-radio-checked .ant-radio-inner {
    border-color: #ed6928;
    background-color: #ed6928;
  }
`;
